import React, { memo, useMemo } from 'react';
import { createUseStyles, useTheme, Modal as ModalComponent, Text } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Modal');

const Modal = (props) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const theme = useTheme();

    const modalProps = useMemo(
        () => ({
            ...props,
            title: props?.description ? (
                <div className={classes.header}>
                    <Text type="h6">{props?.title}</Text>
                    <Text type="subtitle1">{props?.description}</Text>
                </div>
            ) : (
                props?.title
            ),
            cancelText: props?.cancelText || t('action_cancel'),
            confirmText: props?.confirmText || t('action_save'),
            useAutoWidth: true,
            width: '752px',
            overrides: {
                container: {
                    style: {
                        backgroundColor: theme.colors.grey[50],
                    },
                },
                content: {
                    style: {
                        backgroundColor: theme.colors.primary.white,
                        padding: 16,
                        borderRadius: 8,
                    },
                },
                overlay: {
                    style: { zIndex: 1001 },
                },
                preComponent: {
                    style: {
                        display: 'grid',
                        gridAutoFlow: 'row',
                        gridGap: 8,
                    },
                },
            },
        }),
        [classes.header, props, t, theme],
    );

    return <ModalComponent {...modalProps}>{props?.children}</ModalComponent>;
};

export default memo(Modal);
